import { customInstance } from '@/features/auth/axios-config'

import {
  TEMPLATE_DEFAULT_SORT,
  TEMPLATE_LIST_PAGINATION_LIMIT,
  TEMPLATES_BASE_URL,
} from './constants'
import type { ListTemplatesRequest, ListTemplatesResponse } from './types'

/**
 * Fetch list of comment templates
 */
export const listTemplates = async (
  params: ListTemplatesRequest = {}
): Promise<ListTemplatesResponse> => {
  const requestBody: ListTemplatesRequest = {
    filter_by: params.filter_by ?? {},
    limit: params.limit ?? TEMPLATE_LIST_PAGINATION_LIMIT,
    offset: params.offset ?? 0,
    q: params.q ?? '',
    sort_by: params.sort_by ?? TEMPLATE_DEFAULT_SORT,
  }

  return customInstance<ListTemplatesResponse>({
    method: 'post',
    url: `${TEMPLATES_BASE_URL}/list`,
    data: requestBody,
  })
}
